import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { Movie } from '../shared/movie.model'

@Component({
  selector: 'cm-movie-card',
  templateUrl: './movie-card.component.html',
  styleUrls: ['./movie-card.component.css'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class MovieCardComponent implements OnInit {

  @Input() movie: Movie
  @Input() selected = false

  @Output() select = new EventEmitter<boolean>()

  loaded = false

  constructor() {}

  ngOnInit() {

  }

  getBannerUrl(movie: Movie) {
    let bannerUrl = movie.getBannerUrl('en')

    if (bannerUrl === 'tvbanners/generic/generic_tvbanners_v5.png') {
      bannerUrl = '../../../assets/img/movies/generic_tvbanners.png'
    } else {
      bannerUrl = 'http://developer.tmsimg.com/' + bannerUrl + '?api_key=9h6jvc6de4ez8xwy53khs5bw'
    }

    return bannerUrl
  }

  toggleSelect(event: Event) {
    event.stopPropagation()

    this.selected = !this.selected
    this.select.emit(this.selected)
  }

  onError(event: Event) {
    event.srcElement.setAttribute('src', '/assets/img/movies/generic_tvbanners.png')
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/movies/movie-card/movie-card.component.ts